import { Card } from 'react-bootstrap';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { connect } from 'react-redux';
import BaseFeature from './BaseFeature';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import { ZERO_TO_TEN } from '../../../../../../utils/constantFeatures';
import { getErrorIssues } from '../../../../../../utils/validationSummary';

class ZeroToTen extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        const v = value;
        this.props.handleChange(propertyName, v);
    }

    render() {
        const minimumDimmingLevel = this.props.properties[ZERO_TO_TEN.minimumDimmingLevel];
        const dim2off = this.props.properties[ZERO_TO_TEN.dim2off];

        const dataChart = this.getDataChart(this.props.properties);
        return (
            <div>
                <div className="flex-row">
                    <Card className={this.getClassName([minimumDimmingLevel])}>
                        <div className="card-header-feature">
                            {'Setting'}
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            {
                                dim2off != null &&
                                <PropertySwitch
                                    property={dim2off}
                                    title={dim2off.info.displayName}
                                    handleChange={this.handleChange} />
                            }
                            <PropertyPicker
                                style={{ marginTop: '0.5rem' }}
                                property={minimumDimmingLevel}
                                inputPadding={'padding-none'}
                                title={'Min DIM Level'}
                                measureUnit={'%'}
                                min={minimumDimmingLevel.valueMeta.min}
                                max={minimumDimmingLevel.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                id={"zeroToTen"}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                x={{ 'title': '0-10V Interface (V)' }}
                                y={{ 'title': 'Output Level (%)' }}
                                max={{ x: 10, y: 120 }}
                                tickValues={{ x: [], y: [] }}
                                xLabels={this.getXLabels(dataChart)}
                                yLabels={this.getYLabels(dataChart)}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'minimumDimmingLevel-0':
                    ticks.push(el.x);
                    labels.push({ label: el.x, x: el.x });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels() {
        const labels = {};

        //insert max label if max value is not present
        const max = 100;
        if (!labels[max]) {
            labels[max] = { label: max, y: max };
        }

        //insert min label if min value is not present
        const min = this.props.properties[ZERO_TO_TEN.minimumDimmingLevel].value;
        if (!labels[min]) {
            labels[min] = { label: min, y: min };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChart(properties) {

        let dataChart = [{}, {}, {}, {}, {}, {}];
        const dim2off = properties[ZERO_TO_TEN.dim2off]
        let xdimoff = 0.7
        if (dim2off != null && dim2off.value != "1")
            xdimoff = 0

        dataChart[0] = {
            x: 0,
            y: 0,
            timeLabel: "minimumDimmingLevel-0",
        }

        dataChart[1] = {
            x: xdimoff,
            y: (xdimoff == 0) ? properties[ZERO_TO_TEN.minimumDimmingLevel].value : 0,
            timeLabel: "minimumDimmingLevel-0",
        }

        dataChart[2] = {
            x: xdimoff,
            y: +properties[ZERO_TO_TEN.minimumDimmingLevel].value,
            timeLabel: "minimumDimmingLevel-0",
        }

        dataChart[3] = {
            x: properties[ZERO_TO_TEN.xVoltage].valueMeta.min,
            y: +properties[ZERO_TO_TEN.minimumDimmingLevel].value,
            timeLabel: "minimumDimmingLevel-0",
        }

        dataChart[4] = {
            x: properties[ZERO_TO_TEN.xVoltage].valueMeta.max,
            y: 100,
            timeLabel: "minimumDimmingLevel-0",
        }

        dataChart[5] = {
            x: 10,
            y: 100,
            timeLabel: "minimumDimmingLevel-0",
        }

        return dataChart;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ZeroToTen);
